import { createSlice } from "@reduxjs/toolkit";
import VwKurumDTO from "src/models/Settings/Generals/VwKurumDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

export class KurumModel extends VwKurumDTO {
    sozlesmeNo: string;
    tarifeId: number;
}
export interface IKurumState {
    data: Array<KurumModel>;
    value: KurumModel;
    isFetching: boolean;
    errorMessage: string;
}

const KurumSlice = createSlice<IKurumState, MapReducerPayloads<IKurumState, {
    setState: IKurumState,
}>>({
    name: 'KurumState',
    initialState: {
        data: [],
        value: null,
        isFetching: true,
        errorMessage: ""
    },
    reducers: {
        setState: (state, action) => action.payload
    }
})
export default KurumSlice;